import React, { useEffect, useState } from "react";
import {
	Button,
	Container,
	Grid,
	Icon,
	TextField
} from "@mui/material";
import { makeStyles, withStyles } from "@mui/styles";
import clsx from "clsx";
import { showAlertAutoDis } from "../../../utils/utils";


const useStyles = makeStyles((theme) => ({
	button: {
		margin: theme.spacing(1),
		lineHeight: 1.5,
		backgroundColor: '#02ba04',
		borderColor: '#02ba04',
	},
	root: {
		'& .MuiPaper-elevation1': {
			boxShadow: 'none'
		}
	}
}));

const CheckoutFormFlywire = (props) => {
	const {siteUrl} = window;
	const apiURL = document.head.querySelector('meta[name="api-url"]');
	const {
		payThisMuch,
		billingDetails,
		sendFlywireToken = Function.prototype,
		bookingId,
		returnURLDestination
	} = props;
	const splitName = billingDetails.name.split(' ');
	const classes = useStyles();
	const [configFlywire, setConfigFlywire] = useState({
		env: "prod",
		recipientCode: "DNA",
		recurringType: "optional_tokenization",
		requestPayerInfo: true,
		requestRecipientInfo: true,
		recipientFields: {
			booking_reference: bookingId,
			booking_id: bookingId,
		},
		skipCompletedSteps: true,

		onInvalidInput: function (errors) {
			errors.forEach(function (error) {
				showAlertAutoDis({ title: 'Payment Error', text: error.msg });
			});
		},
		onCompleteCallback: async function (args) {
			showAlertAutoDis({title: 'Success', text: 'Payment Completed, you will received an email from us'});
		},

		readonlyFields: ["booking_reference", "client_id","email"],

		paymentOptionsConfig: {
			sort: [
				{ currency: ["local", "foreign"] },
				{ amount: "asc" },
				{ type: ["bank_transfer", "credit_card", "online"] },
			],
			// filters: {
			// 	type: ['bank_transfer','online', 'credit_card'],
			// 	// currency: ['local','foreign','fx']
			// }
		},

		callbackId: bookingId,
		callbackUrl: apiURL.content + 'flywire-callback-url',
		callbackVersion: "2",
		returnUrl: returnURLDestination ?? siteUrl
	});

	useEffect(() => {
		setConfigFlywire({
			...configFlywire,
			firstName: splitName[0] ? splitName[0] : '',
			lastName: splitName[1] ? splitName[1] : '',
			email: billingDetails.email,
			amount: payThisMuch,
		})
	}, [billingDetails, payThisMuch]);


	const handleSubmit = (event) => {
		event.preventDefault();

		const modal = window.FlywirePayment.initiate(configFlywire);
		modal.render();
	};

	return (
		<Container maxWidth={'sm'} style={{ minWidth: 350 }} className={classes.root}>
			<Grid container direction="row" justify="center" alignItems="center" style={{ padding: '30px 0px' }}>
				<Grid item xs={12} sx={{ px: '10px' }}>
					<Button
						variant="contained"
						color="primary"
						type="button"
						fullWidth
						className={clsx({ [classes.button]: true, 'payButton': true })}
						style={{ margin: 0 }}
						startIcon={<Icon>payment</Icon>}
						onClick={handleSubmit}
						sx={{ '&:hover': { backgroundColor: '#50D853' } }}
					>
						Pay
					</Button>
				</Grid>
			</Grid>
		</Container>
	);
}

export default CheckoutFormFlywire;